define('views/base/collection_view',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Marionette.LayoutView.extend({
        tagName: 'div',
        className: 'grid-container',
        searchTimeout: null,
        fetchTrigger: null,

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                searchField: '.search-table',
                filterField: '.filter-field',
                filterDropdown: '.filter-dropdown'
            };
        },

        events: {
            'keyup @ui.searchField': 'searchFieldChanged',
            'paste @ui.searchField': 'searchFieldChanged',

            'change @ui.filterField': 'filterChanged',
            'click @ui.filterDropdown': 'filterDropdownClicked',
            'select2:unselect @ui.select2Input': 'select2UnSelect'
        },

        regions: function() {
            return {
                ListContainer: ".list-container",
                OptionContainer: ".option-container"
            };
        },

        templateHelpers: function() {
            return {
                collection: this.collection,
                searchQuery: this.collection.query,
                filters: this.collection.filters
            };
        },

        onRender: function () {
            var _this = this;

            this.ui.select2Input.select2();

            this.ui.filterDropdown.find('.date-range-picker').each(function () {
                $(this).daterangepicker({
                    timePicker: false,
                    format:'YYYY-MM-DD',
                    autoApply: true
                });

                $(this).on('hide.daterangepicker', function () {
                    var key = $(this).attr('name');
                    var startDate = $(this).data('daterangepicker').startDate.format('YYYY-MM-DD');
                    var endDate = $(this).data('daterangepicker').endDate.format('YYYY-MM-DD');

                    _this.collection.changeFilter(key + '_min', startDate);
                    _this.collection.changeFilter(key + '_max', endDate);
                    _this.collection.fetch();
                });
            });

            if (this.afterRender) {
                this.afterRender();
            }
        },

        searchFieldChanged: function () {
            var _this = this;

            if (this.searchTimeout) {
                window.clearTimeout(this.searchTimeout);
                this.searchTimeout = null;
            }

            var searchQuery = this.ui.searchField.val();
            this.collection.changeSearchQuery(searchQuery);

            this.searchTimeout = window.setTimeout(function () {
                _this.searchTimeout = null;
                _this.collection.fetch();
            }, 1000);
        },

        filterChanged: function (event) {
            var changedField = event.currentTarget;

            var key =  $(changedField).attr('name');
            var value = $(changedField).val();

            if (changedField.type == 'select-multiple') {
                // For multi selects, convert list into comma separated string
                value = value ? value.join() : null;
            }

            this.collection.changeFilter(key, value);
            this.collection.fetch();
        },

        filterDropdownClicked: function (event) {
            // Disable dropdown close on click inside dropdown content
            event.stopPropagation();
        },

        select2UnSelect: function (event) {
            if (!event.params.originalEvent) {
                return;
            }

            event.params.originalEvent.stopPropagation();
        }
    });
});
